import React, { useState } from "react";
import { Grid, Container } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import MultiDocs from "../../components/MultiDocs";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import api from "../../globals/axios";
import { useNavigate } from "react-router-dom";
import SubmittingPopup from "../../components/Custom/FormSubmitPopup";
import { useAlert } from "../../components/Alert";
export default function FinancialDocuments() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const { showAlert } = useAlert();
  const [extraDocs, setExtraDocs] = useState([
    { name: "FY2023" },
    {
      name: "FY2022",
    },
    { name: "FY2021" },
    { name: "Others" },
  ]);
  const onFileChange = (e, index) => {
    if (extraDocs && extraDocs[index] !== undefined) {
      const updatedDocs = [...extraDocs];
      updatedDocs[index] = { ...updatedDocs[index], file: e.target.files[0] };
      setExtraDocs(updatedDocs);
    }
  };
  const onDocumentNameChange = (e, index) => {
    const updatedDocs = [...extraDocs];
    updatedDocs[index] = { ...updatedDocs[index], name: e.target.value };
    setExtraDocs(updatedDocs);
  };
  const submit = () => {
    const hasValidDocument = extraDocs.some((doc) => doc.file && doc.name);
    if (!hasValidDocument) {
      showAlert("warning", "Please provide both file and name for  document");
      return;
    }
    setSubmitting(true);

    // Create an array to store all promises for each document upload
    const uploadPromises = extraDocs.map((doc) => {
      if (doc.file) {
        const formData = new FormData();
        formData.append("name", doc.name);
        formData.append("document", doc.file);

        return api.post("/fpo/documents/add/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }
    });

    // Use Promise.all to wait for all uploads to complete
    Promise.all(uploadPromises)
      .then((responses) => {
        responses.forEach((response, index) => {
          const doc = extraDocs[index];
          if (response && response.data) {
            showAlert("success", `Document ${doc.name} uploaded successfully`);
          }
        });
        setExtraDocs([]);
        setSubmitting(false);
        setTimeout(() => {
          navigate("/fpo/financials");
        }, 1500);
      })
      .catch((error) => {
        console.error("Error adding document:", error);
        setSubmitting(false);
      });
  };

  const onAddMore = () => {
    setExtraDocs([...extraDocs, {}]);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CustomTitle>{t("Financial Documents")}</CustomTitle>
            <MultiDocs
              extraDocs={extraDocs}
              onFileChange={onFileChange}
              onDocumentNameChange={onDocumentNameChange}
              submit={submit}
              onAddMore={onAddMore}
              t={t}
            />
            {submitting && <SubmittingPopup />}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
